import { useEffect, useState } from 'react'
import { PlateFilter } from '~/api/backend/pages/culturesPageAPI'
import Button from '~/components/buttons/Button'
import DateInput from '~/components/DateInput'
import Dialog from '~/components/Dialog'
import { snakeCaseToTitleCase } from '~/utils/string'
import cs from './is_between_datetime_range_filter_modal.scss'

function IsBetweenDatetimeRangeFilterModal({
  filterField,
  isOpen,
  onClose,
  setFilter,
  existingFilter,
}: {
  filterField: string
  isOpen: boolean
  onClose: () => void
  setFilter: (filterField: string, filter: PlateFilter | null) => void
  existingFilter?: PlateFilter | null
}) {
  const [startTime, setStartTime] = useState<string | null>(null)
  const [endTime, setEndTime] = useState<string | null>(null)
  const handleApply = () => {
    setFilter(filterField, {
      field: filterField as
        | 'first_checked_in_at'
        | 'last_checked_out_at'
        | 'last_generated_at',
      operator: {
        operator_type: 'is_between_datetime_range',
        lower_datetime: startTime,
        upper_datetime: endTime,
      },
    })
    onClose()
  }
  useEffect(() => {
    if (existingFilter && isOpen) {
      if (
        existingFilter.field === 'first_checked_in_at' ||
        existingFilter.field === 'last_checked_out_at' ||
        existingFilter.field === 'last_generated_at'
      ) {
        setStartTime(existingFilter.operator?.lower_datetime || null)
        setEndTime(existingFilter.operator?.upper_datetime || null)
      } else {
        setStartTime(null)
        setEndTime(null)
      }
    } else {
      setStartTime(null)
      setEndTime(null)
    }
  }, [existingFilter, isOpen])
  const renderDialogBody = () => {
    return (
      <div className={cs.isBetweenDatetimeRangeFilterModal}>
        <div className={cs.title}>Filter by {snakeCaseToTitleCase(filterField)}</div>
        <div className={cs.controls}>
          <DateInput
            value={startTime}
            onChange={setStartTime}
            className={cs.dateInput}
            showTime
            showActionsBar
            label='Start Time'
            todayButtonText='Now'
            canClearSelection
          />
          <DateInput
            value={endTime}
            onChange={setEndTime}
            className={cs.dateInput}
            showTime
            showActionsBar
            label='End Time'
            todayButtonText='Now'
            canClearSelection
          />
        </div>
        <div className={cs.footer}>
          <Button
            type='normal'
            onClick={onClose}
            className={cs.button}
            label='Cancel'
          />
          <Button
            type='primary'
            label='Apply'
            className={cs.button}
            onClick={handleApply}
            disabled={!startTime && !endTime}
          />
        </div>
      </div>
    )
  }
  return (
    <Dialog isOpen={isOpen} onClose={onClose} className={cs.confirmStartWorkcellDialog}>
      {renderDialogBody()}
    </Dialog>
  )
}
export default IsBetweenDatetimeRangeFilterModal
